<template>
  <div class="partners">
    <h4>{{ $t('graphs.partners') }}</h4>

    <b-tabs class="tabs">
      <b-tab
        v-for="(chart, index) in charts"
        :key="index"
        :title="chart.title"
        class="item-graph"
      >
        <canvas :id="chart.id"></canvas>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'PartnersGraph',
  // eslint-disable-next-line vue/require-prop-types
  props: ['period'],

  data() {
    return {
      charts: [
        {
          id: 'partnerprofit',
          type: 'bar',
          data: [],
          title: this.$t('graphs.payment'),
          stacked: true,
          currency: '$',
          colors: [],
          chart: [],
        },
        {
          id: 'bookсount',
          type: 'bar',
          title: this.$t('graphs.requests_number'),
          options: [],
          labels: [],
          chart: [],
          colors: [
            'rgb(179, 229, 252)',
            'rgb(77, 182, 172)',
            'rgb(239, 83, 80)',
            'rgb(41, 182, 246)',
            'rgba(255,0,0,0.2)',
            'rgba(255,153,0,0.2)',
            'rgb(153, 153, 153)',
            'rgb(255, 112, 67)',
            'rgb(149, 117, 205)',
          ],
        },
      ],
    }
  },

  mounted() {
    this.$watch('period', this.fetch, { deep: true, immediate: true })
  },

  methods: {
    fetch() {
      this.$uiBlocker(
        this.$http
          .get('charts/partnersdata', {
            params: {
              from: this.period.gte,
              to: this.period.lte,
              division_id: this.currentDivision.id,
            },
          })
          .then(({ data }) => {
            this.draw(data)
          }),
        this.$el,
      )
    },

    draw(data) {
      // this.$refs.chart
      this.charts.forEach(chart => {
        this.setOptions(chart, data)

        let ctx = document.getElementById(chart.id).getContext('2d')

        let graph = chart.chart
        if (Object.keys(graph).length !== 0) {
          graph.destroy()
        }

        if (chart.stacked) {
          this.createStackedBar(ctx, chart)
        } else {
          this.createBar(ctx, chart)
        }
      })
    },

    createStackedBar(ctx, chart) {
      let data = chart.data
      let labels = []
      let cash = []
      let stripe = []

      data.forEach(info => {
        labels.push(info.name)
        cash.push(info.cash)
        stripe.push(info.stripe)
      })

      let graph = new Chart(ctx, {
        type: chart.type,
        barPercentage: 12,
        data: {
          labels: labels,
          datasets: [
            {
              data: cash,
              label: this.$t('graphs.cash'),
              backgroundColor: '#66bb6a',
              borderWidth: 2,
            },
            {
              data: stripe,
              label: this.$t('graphs.stripe'),
              backgroundColor: 'rgb(149, 117, 205)',
              borderWidth: 2,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true,
              },
            ],
            yAxes: [
              {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
      })

      chart.chart = graph
    },

    createBar(ctx, chart) {
      let graph = new Chart(ctx, {
        type: chart.type,
        barPercentage: 12,
        data: {
          labels: chart.labels,
          datasets: [
            {
              data: chart.options,
              backgroundColor: chart.colors,
              borderWidth: 2,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            xAxes: [
              {
                barPercentage: 0.4,
              },
            ],
          },
        },
      })

      chart.chart = graph
    },

    setOptions(chart, data) {
      if (chart.id === 'bookсount') {
        chart.labels = Object.keys(data[chart.id])
        chart.options = Object.values(data[chart.id])
      }

      if (chart.id === 'partnerprofit') {
        chart.data = data[chart.id]
      }
    },
  },
}
</script>
